'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_data_Segments$ProblemCard(title, body, icon) {
  this.ir = null;
  this.ip = null;
  this.iq = null;
  this.ir = title;
  this.ip = body;
  this.iq = icon;
}
export { $c_Lio_intela_sites_digitalinternship_data_Segments$ProblemCard as $c_Lio_intela_sites_digitalinternship_data_Segments$ProblemCard };
$p = $c_Lio_intela_sites_digitalinternship_data_Segments$ProblemCard.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_digitalinternship_data_Segments$ProblemCard;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_data_Segments$ProblemCard() {
}
export { $h_Lio_intela_sites_digitalinternship_data_Segments$ProblemCard as $h_Lio_intela_sites_digitalinternship_data_Segments$ProblemCard };
$h_Lio_intela_sites_digitalinternship_data_Segments$ProblemCard.prototype = $p;
$p.N = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.s = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().W(this, (-1928005453), true);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lio_intela_sites_digitalinternship_data_Segments$ProblemCard) && (((this.ir === x$0.ir) && (this.ip === x$0.ip)) && (this.iq === x$0.iq))));
});
$p.t = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().V(this);
});
$p.G = (function() {
  return 3;
});
$p.I = (function() {
  return "ProblemCard";
});
$p.H = (function(n) {
  switch (n) {
    case 0: {
      return this.ir;
      break;
    }
    case 1: {
      return this.ip;
      break;
    }
    case 2: {
      return this.iq;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$ProblemCard(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bE)));
}
export { $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$ProblemCard as $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$ProblemCard };
var $d_Lio_intela_sites_digitalinternship_data_Segments$ProblemCard = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_data_Segments$ProblemCard, "io.intela.sites.digitalinternship.data.Segments$ProblemCard", ({
  bE: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_digitalinternship_data_Segments$ProblemCard as $d_Lio_intela_sites_digitalinternship_data_Segments$ProblemCard };
//# sourceMappingURL=io.intela.sites.digitalinternship.data.-Segments$-Problem-Card.js.map
